module.exports = __webpack_public_path__ + "static/img/cabinet12_9.78a58532.gif";